// extracted by mini-css-extract-plugin
module.exports = {"radioBlock":"CheckboxBlock_radioBlock__14B-t","name":"CheckboxBlock_name__2yJt4"};